export enum BadgeType {
    VIP_DISCOUNT = 'VIP_DISCOUNT',
    AUTO_APPLIED = 'AUTO_APPLIED',
    PRICE_PEEK = 'PRICE_PEEK',
    INSTANT_CONFIRMATION = 'INSTANT_CONFIRMATION',
    DISCOUNT = 'DISCOUNT',
    FREE_CANCELLATION = 'FREE_CANCELLATION',
    TRENDING = 'TRENDING',
    BOOKING_COUNT_ALL_TIME = 'BOOKING_COUNT_ALL_TIME',
    BOOKING_COUNT_LAST_TWENTY_FOUR_HOURS = 'BOOKING_COUNT_LAST_TWENTY_FOUR_HOURS',
    TOP_IN_CATEGORY = 'TOP_IN_CATEGORY',
    BEST_SELLER = 'BEST_SELLER',
    POPULAR = 'POPULAR',
    TOP_TOUR = 'TOP_TOUR',
    MUST_VISIT = 'MUST_VISIT',
    UNKNOWN = 'UNKNOWN',
}
